import React, { useEffect, useState } from "react";
import { updateAdminStatus } from "../../firebase";
import { useParams, useNavigate } from "react-router-dom";
import { Box, CssBaseline, Grid } from "@mui/material";
import { Typography, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import logoImage from "../../assets/images/logoblue.png";
import { routes, showNotification } from "../../constants";
// import { updateAdminInvite } from "../../modules/Admins/hooks/AdminsHook";
import { useAuth } from "../../hooks";

export default function AcceptAdminInvite() {
  const { onLogout } = useAuth();
  const [statusMessage, setStatusMessage] = useState("");
  const { ref, status } = useParams();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    onLogout();
    // handleUpdateUser();
    // alert("Please set your password");
  }, []); // This will call handleUpdateUser only once when the component is mounted
  
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleUpdateUser = async (event) => {
    event.preventDefault();
    try {
      if (ref) {
        setLoading(true);
        if (!password || password.length < 6) {
          setPasswordError("Password must be at least 6 characters");
          alert("Password must be at least 6 characters");
          setLoading(false);
          return;
        } else {
          setPasswordError("");
        }

        let statusUpdateData = {
          status: "accepted",
        };
        let response = await updateAdminStatus({
          id: ref,
          status: status == "accepted" ? "active" : "inactive",
          password: password,
        });
        // let updateInviteResponse = await updateAdminInvite(
        //   statusUpdateData,
        //   ref
        // );

        let isSuccess = response?.data?.status ? true : false;
        let alreadyProcessed = response?.data?.alreadyProcessed ? true : false;

        if (alreadyProcessed) {
          setStatusMessage("Your response has already been processed.");
        } else if (isSuccess) {
          setStatusMessage(`Thank you.Invite ${status} successfully`);
          showNotification("User updated successfully.");
          handleRedirect();
        } else {
          setStatusMessage("Something went wrong");
        }
        setLoading(false);
      }
    } catch (error) {
      console.log("error updating user", error.message);
    } finally {
    }
  };
  const handleRedirect = () => {
    navigate(routes.login);
  };

  return (
    <Box>
      <Box sx={mainContainerStyles}>
        <CssBaseline />

        <Grid
          container
          direction="column"
          alignItems="center"
          spacing={2}
          maxWidth="336px"
        >
          <Grid item>
            <img src={logoImage} alt="Logo" style={logoStyles} />
          </Grid>

          <form onSubmit={handleUpdateUser}>
            <Grid
              item
              display={"flex"}
              flexDirection="column"
              gap={"4px"}
              spacing={2}
              width="100%"
              marginTop="10px"
            >
              <Typography>Set Your Password</Typography>
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  // value={password}
                  // onChange={handlePasswordChange}
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  error={!!passwordError}
                  helperText={passwordError}
                  placeholder="Enter your password"
                  style={{
                    ...textfieldStyles,
                    marginBottom: "10px",
                  }}
                />
                <div style={passwordIconStyles}>
                  <IconButton onClick={togglePasswordVisibility} edge="end">
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </div>
              </div>
            </Grid>
            <Grid item width={"336px"} marginTop="15px">
              <LoadingButton
                variant="contained"
                color="primary"
                type="submit"
                loading={loading}
                // onClick={handleSubmit}
                style={loginButtonStyles}
              >
                Submit
              </LoadingButton>
              {statusMessage}
            </Grid>
          </form>
          {statusMessage === "Thank you.Invite accepted successfully" ||
            (statusMessage == "Your response has already been processed." && (
              <LoadingButton
                variant="contained"
                color="primary"
                type="submit"
                loading={false}
                onClick={handleRedirect}
                style={loginButtonStyles}
              >
                Go To Login
              </LoadingButton>
            ))}
        </Grid>
      </Box>
    </Box>
  );
}

const mainContainerStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
};
const passwordIconStyles = {
  position: "absolute",
  top: "42%",
  right: "13px",
  transform: "translateY(-50%)",
};
const logoStyles = { width: "335.99px", height: "86px", color: "#00A7CD" };
const textfieldStyles = {
  width: "100%",
  height: "48px",
  borderRadius: "8px",
  border: "2px solid #00A7CD",
  fontSize: "16px",
  padding: "12px",
};
const loginButtonStyles = {
  width: "100%",
  height: "34px",
  borderRadius: "4px",
  backgroundColor: "#00A7CD",
};
